import React from 'react';
import { FadeIn } from './FadeIn';
export function PainSection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-338">
      <div className="max-w-3xl mx-auto" data-id="element-339">
        <FadeIn data-id="element-340">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-green-deep text-center mb-12" data-id="element-341">
            💔 ¿ESTO TE SUENA FAMILIAR?
          </h2>
        </FadeIn>

        <div className="space-y-6 text-text-main font-body text-base md:text-lg leading-relaxed" data-id="element-342">
          <FadeIn delay={0.1} data-id="element-343">
            <p data-id="element-344">Son las 2 de la mañana.</p>
            <p data-id="element-345">Tu hijo tiene fiebre otra vez.</p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-346">
            <div className="w-12 h-px bg-green-mint/50 my-4" data-id="element-347"></div>
            <p data-id="element-348">
              Y vos estás parada en la cocina, con el termómetro en la mano y el
              corazón en la garganta —{' '}
              <strong data-id="element-349">
                pensando exactamente lo mismo que pensaste la última vez:
              </strong>
            </p>
            <p className="italic text-green-deep font-medium mt-2" data-id="element-350">
              "¿Por qué siempre le pasa esto a él?"
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-351">
            <div className="w-12 h-px bg-green-mint/50 my-4" data-id="element-352"></div>
            <p data-id="element-353">
              El invierno pasado fueron <strong data-id="element-354">4 anginas.</strong>
            </p>
            <p data-id="element-355">Antes, 2 otitis.</p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-356">
            <p data-id="element-357">
              Y el pediatra, que es buena persona y hace lo que puede, te miró y
              te dijo lo de siempre:
            </p>
            <blockquote className="bg-green-mint/20 border-l-4 border-green-lime p-4 md:p-6 rounded-r-xl my-6 text-green-deep italic font-medium" data-id="element-358">
              "Tranquila, mamá. Es normal. Los chicos de jardín se enferman
              mucho."
            </blockquote>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-359">
            <p data-id="element-360">
              <strong data-id="element-361">Normal.</strong>
            </p>
            <p data-id="element-362">Cuatro ciclos de antibióticos al año es "normal."</p>
            <p data-id="element-363">Mocos que no se van nunca es "normal."</p>
            <p data-id="element-364">
              Un hijo que falta al jardín una semana de cada tres es "normal."
            </p>
          </FadeIn>

          <FadeIn delay={0.6} data-id="element-365">
            <div className="w-12 h-px bg-green-mint/50 my-4" data-id="element-366"></div>
            <p data-id="element-367">
              Pero vos sentís — con esa intuición que ningún médico te puede
              quitar — que algo no está bien. Que tiene que haber una razón. Que
              tiene que haber algo que podés hacer.
            </p>
          </FadeIn>

          <FadeIn delay={0.7} data-id="element-368">
            <p className="text-xl md:text-2xl font-bold text-green-deep mt-8 text-center" data-id="element-369">
              Y tenés razón.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}